parseSchemaExtension